import { Link, useLocation, useNavigate } from "react-router-dom";
import { AccountIcon } from "../../Assets/svgs/AccountIcon";
import { ChatsIcon } from "../../Assets/svgs/ChatsIcon";
import { CreateAssistantIcon } from "../../Assets/svgs/CreateAssistantIcon";
import { DashboardIcon } from "../../Assets/svgs/DashboardIcon";
import { PlansIcon } from "../../Assets/svgs/PlansIcon";
import { ReportsIcon } from "../../Assets/svgs/ReportsIcon";
import { UserIcon } from "../../Assets/svgs/UserIcon";
import logo from "../../Assets/images/logo.png";
import userProfileIcon from "../../Assets/images/VoxApp-Icon.png";
import { useEffect, useRef, useState } from "react";
import { SuccessModel } from "../../Model/SuccessModel";
import { BillingIcon } from "../../Assets/svgs/BillingIcon";
import { CustomerIcon } from "../../Assets/svgs/CustomerIcon";
import { ContactsIcon } from "../../Assets/svgs/ContactsIcon";
import { useDispatch, useSelector } from "react-redux";
import { ConfirmModel } from "../../Model/ConfirmModel";
import { setUnsavedChanges } from "../../Redux/Slice/Common/SelectedTabSlice";
import { getUserData } from "../../Common/utils";
import {
  clearCurrentUserData,
  saveCurrentUserData,
} from "../../Redux/Slice/Common/CurrentUserSlice";
import { getUserById } from "../../Redux/Slice/Users/GetUserById";
import ArrowDownIcon from "../../Assets/svgs/ArrowDownIcon";
import PhoneSidebarIcon from "../../Assets/svgs/PhoneSidebarIcon";
import IntegrationIcon from "../../Assets/svgs/IntegrationIcon";
import CallHistoryIcon from "../../Assets/svgs/CallHistoryIcon";
import { getPlanDetailsOfUser } from "../../Redux/Slice/Plans/GetPlanDetailsOfUserSlice";

export const SideBar = ({ setOpenSidebar }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const sideBarRef = useRef(null);
  const { userPlanFeatures } = useSelector((s) => s?.userPlanDetails);
  const [selectedKey, setSelectedKey] = useState(1);
  const [successModal, setSuucessModal] = useState(false);
  const [successMessage, setSuucessMessage] = useState("");
  const [confirmModal, setCofirmModal] = useState("");
  const [backUpTab, setBackUp] = useState();
  const [showAssistantDocuments, setShowAssistantDocuments] = useState(false);
  const [showSuperAdminAssistantMenus, setShowSuperAdminAssistantMenus] =
    useState(false);
  const currentUserData = useSelector((s) => s?.currentUser?.userData);
  const user = currentUserData ? currentUserData : getUserData();

  const hasUnsavedChanges = useSelector(
    (state) => state.hasUnsavedChanges.hasUnsavedChanges
  );
  const onTabChange = (key, path) => {
    setSelectedKey(key);
    setOpenSidebar(false);
    navigate(path);
  };

  const checkSelectedPath = () => {
    setShowAssistantDocuments(false);
    if (
      location.pathname.includes("subscription") ||
      location.pathname.includes("topup-payment")
    ) {
      setSelectedKey(2);
    } else if (location.pathname.includes("dashboard")) {
      setSelectedKey(1);
    } else if (
      (location.pathname.includes("add-user") ||
        location.pathname.includes("edit-user")) &&
      location?.state?.isFromCustomerUserListing &&
      (userData?.isUserOfVoxApp || userData?.role?.name === "superadmin")
    ) {
      setSelectedKey(4);
    } else if (location.pathname.includes("user")) {
      setSelectedKey(3);
    } else if (location.pathname.includes("customerbilling")) {
      setSelectedKey(7);
    } else if (location.pathname.includes("transaction-history")) {
      {
        userData.role.name === "superadmin"
          ? setSelectedKey(7)
          : setSelectedKey(8);
      }
    } else if (location.pathname.includes("customer")) {
      setSelectedKey(4);
    } else if (location.pathname.includes("plan")) {
      setSelectedKey(2);
    } else if (location.pathname.includes("assistant/documents")) {
      setShowAssistantDocuments(true);
      setSelectedKey(12);
    } else if (location.pathname.includes("assistant/form-submission")) {
      setShowAssistantDocuments(true);
      setSelectedKey(13);
    } else if (location.pathname.includes("assistant/functions")) {
      setShowAssistantDocuments(true);
      setSelectedKey(15);
    } else if (location.pathname.includes("assistant/knowledge-base")) {
      setShowAssistantDocuments(true);
      setSelectedKey(18);
    } else if (location.pathname.includes("meta-assistant-chat")) {
      setShowSuperAdminAssistantMenus(true);
      setSelectedKey(22);
    } else if (location.pathname.includes("chat")) {
      setSelectedKey(9);
    } else if (
      location.pathname == "/meta-assistants" ||
      location.pathname == "/add-meta-assistant"
    ) {
      setShowSuperAdminAssistantMenus(true);
      setSelectedKey(21);
    } else if (location.pathname.includes("assistant")) {
      if (userData.role.name === "superadmin") {
        setShowSuperAdminAssistantMenus(true);
        setSelectedKey(19);
      } else {
        setShowAssistantDocuments(true);
        setSelectedKey(5);
      }
    } else if (location.pathname.includes("addPayment")) {
      setSelectedKey(2);
    } else if (location.pathname.includes("profile")) {
      setSelectedKey(6);
    } else if (location.pathname.includes("reports")) {
      setSelectedKey(10);
    } else if (location.pathname.includes("phoneNumbers")) {
      setSelectedKey(14);
    } else if (location.pathname.includes("call-email-history")) {
      setSelectedKey(16);
    } else if (location.pathname.includes("integration")) {
      setSelectedKey(17);
    } else if (
      location.pathname.includes("contact") ||
      location.pathname.includes("call") ||
      location.pathname.includes("group-call") ||
      location.pathname.includes("add-group") ||
      location.pathname.includes("edit-group") ||
      location.pathname.includes("group-members") ||
      location.pathname.includes("email")
    ) {
      setSelectedKey(11);
    }
  };
  const userData = currentUserData ? currentUserData : getUserData();

  const logoutUser = () => {
    setSuucessMessage("Logout Successfully!");
    setSuucessModal(true);
    setTimeout(() => {
      localStorage.clear();
      dispatch(clearCurrentUserData());
      navigate("/");
    }, 1500);
  };

  const onYes = async () => {
    setCofirmModal(false);
    await dispatch(setUnsavedChanges(false));
    if (backUpTab?.route == "/logout") {
      logoutUser();
    } else {
      onTabChange(backUpTab.selectedTab, backUpTab.route);
    }
  };
  useEffect(() => {
    checkSelectedPath();
  }, [location.pathname]);

  const handleChange = (tabid, route) => {
    if (hasUnsavedChanges) {
      setCofirmModal(true);
      setBackUp({ selectedTab: tabid, route: route });
    } else {
      onTabChange(tabid, route);
    }
  };

  const updateLocalStorageUserData = (latestUserData) => {
    try {
      const oldUserData = JSON.parse(localStorage.getItem("userData"));
      let userData2 = JSON.parse(localStorage.getItem("userData"));
      userData2 = {
        ...oldUserData,
        ...latestUserData,
      };
      userData2 = {
        ...userData2,
        customer: latestUserData?.customer
          ? {
              ...oldUserData?.customer,
              ...latestUserData?.customer,
            }
          : null,
      };
      localStorage.setItem("userData", JSON.stringify(userData2));
      dispatch(saveCurrentUserData(userData2));
    } catch (error) {}
  };

  const getUserProfile = async () => {
    try {
      const resutOfUserDetails = await dispatch(getUserById(userData?.id));
      if (
        getUserById.fulfilled.match(resutOfUserDetails) &&
        resutOfUserDetails?.payload?.success === true
      ) {
        const currentUserDetails = resutOfUserDetails?.payload?.data;
        if (currentUserDetails) {
          updateLocalStorageUserData(currentUserDetails);
        }
      }
    } catch (error) {}
  };

  const handleClickOutside = (event) => {
    if (sideBarRef?.current && !sideBarRef?.current?.contains(event.target)) {
      setOpenSidebar(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  useEffect(() => {
    getUserProfile();
    if (userData?.role?.name != "superadmin") {
      dispatch(getPlanDetailsOfUser());
    }
  }, [selectedKey]);

  return (
    <>
      {successModal ? <SuccessModel message={successMessage} /> : ""}
      {confirmModal ? (
        <ConfirmModel
          onAccept={onYes}
          onReject={() => {
            setCofirmModal(false);
          }}
          title="Warning!"
          message={`You have unsaved changes. Are you sure you want to ${
            backUpTab && backUpTab?.route == "/logout" ? "logout" : "continue"
          } without saving?`}
        />
      ) : (
        ""
      )}
      <div className="layoutSidemenu" ref={sideBarRef}>
        <div className="layoutSidemenu__logo">
          <img src={logo} alt="Logo | Vox App" />
        </div>
        <div className="layoutSidemenu__fullHeight">
          <ul className="layoutSidemenu__list">
            <li
              className={
                selectedKey === 1
                  ? "layoutSidemenu__list--item layoutSidemenu__selected"
                  : "layoutSidemenu__list--item"
              }
              onClick={() => handleChange(1, "/dashboard")}
            >
              <div className="layoutSidemenu__list--link">
                <span className="icon">
                  <DashboardIcon />
                </span>
                <span>Dashboard</span>
              </div>
            </li>
            {userData?.isUserOfVoxApp ||
            userData?.role?.name === "superadmin" ? (
              <>
                {" "}
                {userData?.role.name != "employee" ? (
                  <li
                    className={
                      selectedKey === 3
                        ? "layoutSidemenu__list--item layoutSidemenu__selected"
                        : "layoutSidemenu__list--item"
                    }
                    onClick={() => handleChange(3, "/users")}
                  >
                    <div className="layoutSidemenu__list--link">
                      <UserIcon />
                      <span>Users</span>
                    </div>
                  </li>
                ) : (
                  ""
                )}
                <li
                  className={
                    selectedKey === 4
                      ? "layoutSidemenu__list--item layoutSidemenu__selected"
                      : "layoutSidemenu__list--item"
                  }
                  onClick={() => handleChange(4, "/customers")}
                >
                  <div className="layoutSidemenu__list--link">
                    <CustomerIcon />
                    <span>Customers</span>
                  </div>
                </li>
              </>
            ) : (
              <>
                {" "}
                {userData.role.name === "company" ||
                userData.role.name === "admin" ? (
                  <li
                    className={
                      selectedKey === 3
                        ? "layoutSidemenu__list--item layoutSidemenu__selected"
                        : "layoutSidemenu__list--item"
                    }
                    onClick={() => handleChange(3, "/users")}
                  >
                    <div className="layoutSidemenu__list--link">
                      <UserIcon />
                      <span>Users</span>
                    </div>
                  </li>
                ) : (
                  ""
                )}
                {userData.role.name === "superadmin" ? (
                  ""
                ) : (
                  <>
                    {userPlanFeatures?.REPORTING ? (
                      <li
                        className={
                          selectedKey === 10
                            ? "layoutSidemenu__list--item layoutSidemenu__selected"
                            : "layoutSidemenu__list--item"
                        }
                        onClick={() => handleChange(10, "/reports")}
                      >
                        <div className="layoutSidemenu__list--link">
                          <ReportsIcon />
                          <span>Reports</span>
                        </div>
                      </li>
                    ) : null}
                    <li
                      className={`layoutSidemenu__list--item ${
                        showAssistantDocuments ||
                        selectedKey === 12 ||
                        selectedKey === 13 ||
                        selectedKey === 18 ||
                        selectedKey === 15
                          ? "layoutSidemenu__list--item--submenu"
                          : ""
                      } ${
                        selectedKey === 5 ||
                        selectedKey === 12 ||
                        selectedKey === 18 ||
                        selectedKey === 13 ||
                        selectedKey === 15
                          ? "layoutSidemenu__selected"
                          : ""
                      }`}
                      onClick={() => handleChange(5, "/assistants")}
                    >
                      <a className="layoutSidemenu__list--link">
                        <span className="icon icon--assistant">
                          <CreateAssistantIcon />
                        </span>
                        <span>Assistant</span>
                        <span
                          className="arrowDown"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setShowAssistantDocuments((p) => !p);
                          }}
                        >
                          <ArrowDownIcon />
                        </span>
                      </a>
                      {showAssistantDocuments ? (
                        <ul
                          className={`layoutSidemenu__list--submenu ${
                            showAssistantDocuments ? "open" : ""
                          }`}
                        >
                          {userPlanFeatures?.KNOWLEDGE_BASE ? (
                            <>
                              <li
                                className={`layoutSidemenu__list--item ${
                                  selectedKey === 12
                                    ? "layoutSidemenu__selected"
                                    : ""
                                }`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  handleChange(12, "/assistant/documents");
                                }}
                              >
                                <a className="layoutSidemenu__list--link">
                                  <span>Documents</span>
                                </a>
                              </li>
                              <li
                                className={`layoutSidemenu__list--item ${
                                  selectedKey === 18
                                    ? "layoutSidemenu__selected"
                                    : ""
                                }`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  handleChange(18, "/assistant/knowledge-base");
                                }}
                              >
                                <a className="layoutSidemenu__list--link">
                                  <span>Knowledge Base</span>
                                </a>
                              </li>
                            </>
                          ) : null}
                          <li
                            className={`layoutSidemenu__list--item ${
                              selectedKey === 13
                                ? "layoutSidemenu__selected"
                                : ""
                            }`}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleChange(13, "/assistant/form-submissions");
                            }}
                          >
                            <a className="layoutSidemenu__list--link">
                              <span>Forms</span>
                            </a>
                          </li>
                          {userPlanFeatures?.CUSTOM_FUNCTIONS ? (
                            <li
                              className={`layoutSidemenu__list--item ${
                                selectedKey === 15
                                  ? "layoutSidemenu__selected"
                                  : ""
                              }`}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleChange(15, "/assistant/functions");
                              }}
                            >
                              <a className="layoutSidemenu__list--link">
                                <span>Functions</span>
                              </a>
                            </li>
                          ) : null}
                        </ul>
                      ) : null}
                    </li>
                    {/* <li
                      className={
                        selectedKey === 5
                          ? "layoutSidemenu__list--item layoutSidemenu__selected"
                          : "layoutSidemenu__list--item"
                      }
                      onClick={() => handleChange(5, "/assistants")}
                    >
                      <div className="layoutSidemenu__list--link">
                          <CreateAssistantIcon />
                        <span>Create Assistant</span>
                      </div>
                    </li>
                    <li
                      className={
                        selectedKey === 12
                          ? "layoutSidemenu__list--item layoutSidemenu__selected"
                          : "layoutSidemenu__list--item"
                      }
                      onClick={() => handleChange(12, "/assistant/documents")}
                    >
                      <div className="layoutSidemenu__list--link">
                          <CreateAssistantIcon />
                        <span>Documents</span>
                      </div>
                    </li> */}
                    {userPlanFeatures?.MULTIPLE_PHONE_NUMBERS ? (
                      <li
                        className={
                          selectedKey === 14
                            ? "layoutSidemenu__list--item layoutSidemenu__selected"
                            : "layoutSidemenu__list--item"
                        }
                        onClick={() => handleChange(14, "/phoneNumbers")}
                      >
                        <div className="layoutSidemenu__list--link">
                          <span className="icon">
                            <PhoneSidebarIcon />
                          </span>
                          <span>Phone Number</span>
                        </div>
                      </li>
                    ) : null}
                    <li
                      className={
                        selectedKey === 11
                          ? "layoutSidemenu__list--item layoutSidemenu__selected"
                          : "layoutSidemenu__list--item"
                      }
                      onClick={() => handleChange(11, "/contacts")}
                    >
                      <div className="layoutSidemenu__list--link">
                        <span className="icon">
                          <ContactsIcon />
                        </span>
                        <span>Contacts</span>
                      </div>
                    </li>

                    <li
                      className={
                        selectedKey === 16
                          ? "layoutSidemenu__list--item layoutSidemenu__selected"
                          : "layoutSidemenu__list--item"
                      }
                      onClick={() => handleChange(16, "/call-email-history")}
                    >
                      <div className="layoutSidemenu__list--link">
                        <span className="icon">
                          <CallHistoryIcon />
                        </span>
                        <span>Call/Email History</span>
                      </div>
                    </li>
                    {userPlanFeatures?.CHAT_HISTORY ? (
                      <li
                        className={
                          selectedKey === 9
                            ? "layoutSidemenu__list--item layoutSidemenu__selected"
                            : "layoutSidemenu__list--item"
                        }
                        onClick={() => handleChange(9, "/chat")}
                      >
                        <div className="layoutSidemenu__list--link">
                          {/* <span className="icon"> */}
                          <ChatsIcon />
                          {/* </span> */}
                          <span>Chats</span>
                        </div>
                      </li>
                    ) : null}

                    {userPlanFeatures?.CALENDAR_INTEGRATIONS ||
                    userPlanFeatures?.ENTERPRISE_SCALE_AUTOMATIONS_INTEGRATIONS ||
                    userPlanFeatures?.INTEGRATIONS_250_ACTIONS_PER_MONTH ||
                    userPlanFeatures?.INTEGRATIONS_25K_ACTIONS_PER_MONTH ||
                    userPlanFeatures?.AUTOMATION ? (
                      <li
                        className={
                          selectedKey === 17
                            ? "layoutSidemenu__list--item layoutSidemenu__selected"
                            : "layoutSidemenu__list--item"
                        }
                        onClick={() => handleChange(17, "/integration")}
                      >
                        <div className="layoutSidemenu__list--link">
                          <span className="icon">
                            <IntegrationIcon />
                          </span>
                          <span>Integration</span>
                        </div>
                      </li>
                    ) : null}
                  </>
                )}
              </>
            )}
            {userData?.role.name === "superadmin" ||
            userData?.role.name === "company" ||
            userData?.role.name === "admin" ||
            userData?.role.name === "individual" ? (
              <li
                className={
                  selectedKey === 2
                    ? "layoutSidemenu__list--item layoutSidemenu__selected"
                    : "layoutSidemenu__list--item"
                }
                onClick={() => {
                  if (hasUnsavedChanges) {
                    setCofirmModal(true);
                    if (
                      // userData.isUserOfVoxApp ||
                      userData.role.name === "superadmin" ||
                      userData.role.name === "admin"
                    ) {
                      setBackUp({ selectedTab: 2, route: "/plans" });
                    } else {
                      setBackUp({ selectedTab: 2, route: "/subscription" });
                    }
                  } else {
                    if (
                      // userData.isUserOfVoxApp ||
                      userData.role.name === "superadmin" ||
                      userData.role.name === "admin"
                    ) {
                      onTabChange(2, "/plans");
                    } else {
                      onTabChange(2, "/subscription");
                    }
                  }
                }}
              >
                <div className="layoutSidemenu__list--link">
                  <span className="icon">
                    <PlansIcon />
                  </span>
                  <span>Plans</span>
                </div>
              </li>
            ) : (
              ""
            )}
            {userData.role.name === "superadmin" ? (
              <>
                <li
                  className={`layoutSidemenu__list--item ${
                    showSuperAdminAssistantMenus ||
                    selectedKey === 19 ||
                    selectedKey == 21 ||
                    selectedKey == 22
                      ? "layoutSidemenu__list--item--submenu"
                      : ""
                  } ${
                    selectedKey === 19 ||
                    selectedKey === 21 ||
                    selectedKey == 22
                      ? "layoutSidemenu__selected"
                      : ""
                  }`}
                  onClick={() => handleChange(19, "/view-assistants")}
                >
                  <a className="layoutSidemenu__list--link">
                    <span className="icon icon--assistant">
                      <CreateAssistantIcon />
                    </span>
                    <span>Assistant</span>
                    <span
                      className="arrowDown"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setShowSuperAdminAssistantMenus((p) => !p);
                      }}
                    >
                      <ArrowDownIcon />
                    </span>
                  </a>
                  {showSuperAdminAssistantMenus ? (
                    <ul
                      className={`layoutSidemenu__list--submenu ${
                        showSuperAdminAssistantMenus ? "open" : ""
                      }`}
                    >
                      <li
                        className={`layoutSidemenu__list--item ${
                          selectedKey === 20 ? "layoutSidemenu__selected" : ""
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          // handleChange(20, "/assistant/documents");
                        }}
                      >
                        <a className="layoutSidemenu__list--link">
                          <span>Create Template</span>
                        </a>
                      </li>
                      <li
                        className={`layoutSidemenu__list--item ${
                          selectedKey === 21 ? "layoutSidemenu__selected" : ""
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleChange(21, "/meta-assistants");
                        }}
                      >
                        <a className="layoutSidemenu__list--link">
                          <span>Meta Assistant</span>
                        </a>
                      </li>
                      <li
                        className={`layoutSidemenu__list--item ${
                          selectedKey === 22 ? "layoutSidemenu__selected" : ""
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleChange(22, "/meta-assistant-chat");
                        }}
                      >
                        <a className="layoutSidemenu__list--link">
                          <span>Meta Assistant Chat</span>
                        </a>
                      </li>
                      <li
                        className={`layoutSidemenu__list--item ${
                          selectedKey === 19 ? "layoutSidemenu__selected" : ""
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleChange(19, "/view-assistants");
                        }}
                      >
                        <a className="layoutSidemenu__list--link">
                          <span>View Assistant</span>
                        </a>
                      </li>
                    </ul>
                  ) : null}
                </li>
                <li
                  className={
                    selectedKey === 7
                      ? "layoutSidemenu__list--item layoutSidemenu__selected"
                      : "layoutSidemenu__list--item"
                  }
                  onClick={() => handleChange(7, "/customerbilling")}
                >
                  <div className="layoutSidemenu__list--link">
                    <span className="icon">
                      <BillingIcon />
                    </span>
                    <span>Billings</span>
                  </div>
                </li>{" "}
              </>
            ) : (
              ""
            )}
            <li
              className={
                selectedKey === 6
                  ? "layoutSidemenu__list--item layoutSidemenu__selected"
                  : "layoutSidemenu__list--item"
              }
              onClick={() => handleChange(6, "/profile")}
            >
              <div className="layoutSidemenu__list--link">
                <span className="icon icon--accountInformation">
                  <AccountIcon />
                </span>
                <span>Account Information</span>
              </div>
            </li>
          </ul>
        </div>
        <div className="layoutSidemenu__logout">
          <div className="layoutSidemenu__logout__action">
            <div className="userProfile">
              <div className="picIcon">
                <img
                  className="picIcon__img"
                  src={userData?.avatar ? userData?.avatar : userProfileIcon}
                  alt=""
                />
              </div>
              {user.firstName} {user?.lastName}
            </div>
            <button
              className="btnLogout"
              onClick={() => {
                if (hasUnsavedChanges) {
                  setCofirmModal(true);
                  setBackUp({ selectedTab: "", route: "/logout" });
                } else {
                  logoutUser();
                }
              }}
            >
              <svg
                width="11"
                height="11"
                viewBox="0 0 11 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.5851 7.60969C7.48565 7.51078 7.43593 7.39294 7.43593 7.25616C7.43593 7.11939 7.48565 7.00305 7.5851 6.90713L8.48016 6.01696H4.67177C4.53127 6.01696 4.41288 5.96887 4.31658 5.87268C4.22028 5.77648 4.17213 5.65821 4.17213 5.51786C4.17213 5.3775 4.22028 5.25995 4.31658 5.16523C4.41288 5.0705 4.53127 5.02314 4.67177 5.02314H8.45493L7.54013 4.11333C7.44909 4.02688 7.40476 3.91639 7.40713 3.78187C7.40951 3.64736 7.46133 3.53043 7.56258 3.43108C7.65738 3.33173 7.77587 3.28323 7.91807 3.2856C8.06027 3.28796 8.18109 3.33859 8.28054 3.4375L10.0367 5.18405C10.0878 5.23611 10.1254 5.29195 10.1496 5.35155C10.1738 5.41117 10.1858 5.47234 10.1858 5.53506C10.1858 5.59778 10.1738 5.65821 10.1496 5.71634C10.1254 5.77446 10.0878 5.8294 10.0367 5.88115L8.28603 7.62223C8.19499 7.71278 8.08146 7.75805 7.94544 7.75805C7.80943 7.75805 7.68931 7.7086 7.5851 7.60969ZM1.79792 10.2137C1.52259 10.2137 1.28602 10.116 1.08822 9.92067C0.890408 9.72534 0.791504 9.49173 0.791504 9.21986V1.82025C0.791504 1.54642 0.890408 1.31115 1.08822 1.11442C1.28602 0.917696 1.52259 0.819336 1.79792 0.819336H5.01893C5.15942 0.819336 5.27782 0.868819 5.37412 0.967786C5.47042 1.06676 5.51856 1.18622 5.51856 1.32616C5.51856 1.4661 5.47042 1.58343 5.37412 1.67816C5.27782 1.77288 5.15942 1.82025 5.01893 1.82025H1.79792V9.21986H5.01893C5.15942 9.21986 5.27782 9.26795 5.37412 9.36414C5.47042 9.46034 5.51856 9.57861 5.51856 9.71896C5.51856 9.85932 5.47042 9.97686 5.37412 10.0716C5.27782 10.1663 5.15942 10.2137 5.01893 10.2137H1.79792Z"
                  fill="#F8FAFC"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
